export const UPDATE_LIVE_ONLY = 'liveonly';
export const UPDATE_STATIC_ONLY = 'staticonly';
export const UPDATE_BOTH = 'both';
